@charset "UTF-8";

/* src/app/modules/print-cards/components/cards/card-content/shared/components/glass-house-shelf-talker-content/glass-house-shelf-talker-content.component.scss */
.f12px {
  font-size: 0.75rem;
}
.f14px {
  font-size: 0.875rem;
}
.f16px {
  font-size: 1rem;
}
.f18px {
  font-size: 1.125rem;
}
.f20px {
  font-size: 1.25rem;
}
.f24px {
  font-size: 1.5rem;
}
.f32px {
  font-size: 2rem;
}
.f48px {
  font-size: 3rem;
}
.f64px {
  font-size: 4rem;
}
:host {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 0.5rem;
}
:host .glass-house-shelf-talker {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  border: 1px #9f9f9f solid;
}
:host .glass-house-shelf-talker .glass-house-shelf-talker-header {
  width: 100%;
  display: flex;
  align-items: center;
  height: 4.375rem;
  gap: 0.625rem;
  border-bottom: 1px #9f9f9f solid;
}
:host .glass-house-shelf-talker .glass-house-shelf-talker-header .header-title {
  font-family: inter, sans-serif;
  font-weight: 800;
  font-style: normal;
  font-size: 1.5rem;
  overflow: clip;
  overflow-clip-margin: 0;
  text-overflow: ellipsis;
  white-space: normal;
  display: -webkit-box;
  word-break: break-word;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  padding-left: 0.5rem;
  flex: 1 0 0;
  justify-content: center;
  align-content: center;
  text-align: center;
  letter-spacing: 1.3px;
}
:host .glass-house-shelf-talker .glass-house-shelf-talker-header .logo-container {
  justify-content: center;
  align-content: center;
  padding-right: 0.5rem;
}
:host .glass-house-shelf-talker .glass-house-shelf-talker-header .logo-container .header-logo {
  height: 2.625rem;
}
:host .glass-house-shelf-talker .glass-house-shelf-talker-body {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
  flex: 1;
  box-sizing: border-box;
}
:host .glass-house-shelf-talker .glass-house-shelf-talker-body .shelf-talker-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 0.75rem;
  box-sizing: border-box;
}
/*# sourceMappingURL=glass-house-shelf-talker-content.component.css.map */
